import { Drawer, Space, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './index.less';
import React, { useState, useImperativeHandle } from 'react';

const DrawerAcore = ({ children, title = '', height = '85vh', footerBtn = null }, ref) => {
  const [visible, setVisible] = useState(false);
  useImperativeHandle(
    ref,
    () => {
      return {
        show: () => {
          setVisible(true);
        },
        hide: () => {
          setVisible(false);
        },
      };
    },
    []
  );
  return (
    <Drawer
      closable={false}
      className="TY_drawer_wrap"
      title={title}
      placement="bottom"
      visible={visible}
      height={height}
      footer={
        footerBtn === null ? null : (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{footerBtn}</div>
        )
      }
      extra={<CloseOutlined onClick={() => setVisible(false)} />}
    >
      {children}
    </Drawer>
  );
};

export default React.forwardRef(DrawerAcore);
